module.exports = __webpack_public_path__ + "static/media/how-it-works-undercarriage-3.26b4d492.png";